import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../constants/roles';
import { CENTRAL_PHARMACY_PATHS, centralNavItemsForRole } from './pharmacyPaths';
import { PHARMACY_COPY } from './pharmacyCopy';
import PharmacyPortalShell from './PharmacyPortalShell';

export default function CentralPharmacyLayout() {
  const { user } = useAuth();
  return (
    <PharmacyPortalShell
      mode="central"
      allowedRoles={[ROLES.ADMIN, ROLES.ADMIN_PHARMACIST]}
      navItems={centralNavItemsForRole(user?.role)}
      dashboardPath={CENTRAL_PHARMACY_PATHS.DASHBOARD}
      dispensationPath={CENTRAL_PHARMACY_PATHS.DISPENSATION_NEW}
      brandSection={PHARMACY_COPY.LAYOUT.TOPBAR_SECTION_CENTRAL}
      tagline={PHARMACY_COPY.LAYOUT.TOPBAR_TAGLINE_CENTRAL}
      sideMenuTitle={PHARMACY_COPY.LAYOUT.SIDE_MENU_SECTION_CENTRAL}
    />
  );
}
